<template>
  <div>
    <section class="p-box">
      <GMBLocations
        v-if="!loading"
        :max-location-count="maxLocationCount"
        :brand-name="brand.attributes.name"
        :business-groups="businessGroupsCollection"
        :show-gmb-oauth-link="false"
        @on-back="onBack"
        @submit-success="submitSuccess"
      />
      <Loading v-else />
    </section>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import GMBLocations from '../components/GMBLocations'
import Loading from '../components/Loading'

export default {
  name: 'CompaniesGMBLinkageLocations',
  components: {
    GMBLocations,
    Loading
  },
  computed: {
    ...mapState({
      loading: state => state.companiesStores.loading || state.companiesGmbAccounts.loading || state.companiesBrand.loading,
      stores: state => state.companiesStores.data,
      brand: state => state.companiesBrand.data,
      businessGroups: state => state.companiesGmbAccounts.data,
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
    maxLocationCount() {
      return this.stores.meta.max_store_count - this.stores.meta.store_count
    },
    businessGroupsCollection() {
      const obj = {}
      this.businessGroups.data.forEach(v => {
        obj[v.attributes.name] = v.id
      })
      return obj
    },
  },
  created() {
    this.readBusinessGroups(this.currentCompanyUuid)
    this.readStores(this.currentCompanyUuid)
    this.readBrand({ company_uuid: this.currentCompanyUuid, brand_id: this.$route.params.brand_id })
  },
  methods: {
    ...mapActions({
      readBusinessGroups: 'companiesGmbAccounts/readCompaniesGmbAccounts',
      readStores: 'companiesStores/readStores',
      readBrand: 'companiesBrand/readBrand',
    }),
    submitSuccess() {
      this.$router.push(`/s/companies/${this.currentCompanyUuid}/location/stores`)
      this.$updateFlash({ type: 'notice', message: '店舗一括登録を行いました(反映まで数分かかる場合があります)' })
    },
    onBack() {
      this.$router.push(`/s/companies/${this.currentCompanyUuid}/gmb/brands`)
    },
  }
}
</script>

<style lang="scss" scoped>
.p-box {
  padding: 60px 20px;
}
.p-box__body {
  ul {
    li {
      margin-bottom: 6px;
    }
  }
}
</style>
